import padStart from "lodash/padStart";
const generateRandomColor = () => `#${padStart(Math.floor(Math.random() * 0xffffff).toString(16), 6, "0")}`;
export default generateRandomColor;
